import Graphemer from 'graphemer';

/**
 * Разделяет сообщение с html тегами и графемами на несколько сообщений по заданной длине
 * @param message текст сообщения с html тегами и графемами (эмодзи и символы)
 * @param maxLength максимальная длина сообщения
 * @returns массив сообщений
 */
export const splitMessage = (message: string, maxLength: number) => {
  const splitter = new Graphemer();

  // INFO: Регулярное выражение для html тегов
  const regex = /(<[^>]+>)/g;

  // INFO: Разбиваем на теги и текст
  const parts = message.split(regex);

  const result: string[] = [];
  let current = '';
  let currentLen = 0;

  for (const part of parts) {
    if (part.startsWith('<') && part.endsWith('>')) {
      // INFO: Тег добавляем целиком
      if (currentLen + part.length > maxLength) {
        // INFO: Сохраняем текущую часть и начинаем новую
        result.push(current);
        current = '';
        currentLen = 0;
      }
      current += part;
      currentLen += part.length;
    } else {
      // INFO: Текст делим на графемы (эмодзи и символы)
      const graphemes = splitter.splitGraphemes(part);

      for (const grapheme of graphemes) {
        if (currentLen + grapheme.length > maxLength) {
          // INFO: Сохраняем текущую часть и начинаем новую
          result.push(current);
          current = '';
          currentLen = 0;
        }
        current += grapheme;
        currentLen += grapheme.length;
      }
    }
  }

  if (current) {
    result.push(current);
  }

  return result;
};
